module.exports = __webpack_public_path__ + "img/M300LC-Y3F.a598dd91.png";